const convertColorToRgba = require('../convertColorToRgba');
const convertRgbToHsv = require('../convertRgbToHsv');

/**
 * Converts hex color to hsv object
 * @param {String} hex - hex representation of color
 * @returns {Object} hsv object
 */
const convertHexToHsv = (hex) => {
    const { r, g, b } = convertColorToRgba(hex);

    return convertRgbToHsv(r, g, b);
};

module.exports = convertHexToHsv;
